import React, { useState } from "react";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import RealitySection from "@/components/RealitySection";
import HowItWorks from "@/components/HowItWorks";
import MarketplacePreview from "@/components/MarketplacePreview";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import TrustStrip from "@/components/TrustStrip";
import AvniSection from "@/components/AvniSection";
import CTASection from "@/components/CTASection";
import MissionSection from "@/components/MissionSection";
import SeoIntro from "@/components/SeoIntro";
import { useMarketplaceAgents } from "@/lib/marketplaceStore";

export default function LandingPage() {
  const { agents, loading } = useMarketplaceAgents();
  const [avniSeed, setAvniSeed] = useState(null);

  const askAvni = (seed) => {
    setAvniSeed({ text: seed, ts: Date.now() }); // ts ensures new seed each click
    setTimeout(() => {
      const el = document.getElementById("avni");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  return (
    <div data-testid="landing-page">
      <Hero />
      <StatsBar />
      <RealitySection onAskAvni={askAvni} />
      <MissionSection />
      <HowItWorks />
      <MarketplacePreview agents={agents} loading={loading} compact={true} />
      <Testimonials />
      <Pricing />
      <TrustStrip />
      <AvniSection seed={avniSeed} />
      <CTASection />
      <SeoIntro />
    </div>
  );
}
